import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchCoupangReviewFailures, verifyCoupangReviewFailure } from './index';
import { COUPANG_REVIEW_FAILURE_QUERY_KEYS } from './queryKeys';
import type { CoupangReviewState, VerifyCoupangReviewFailureRequest } from './types';

export const useCoupangReviewFailures = (
  filters: { state: CoupangReviewState; limit: number; cursor?: string },
  options?: { enabled?: boolean },
) =>
  useQuery({
    queryKey: COUPANG_REVIEW_FAILURE_QUERY_KEYS.list(filters.state, filters.limit, filters.cursor),
    queryFn: () => fetchCoupangReviewFailures(filters),
    enabled: options?.enabled ?? true,
    staleTime: 15_000,
  });

export const useVerifyCoupangReviewFailure = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ productId, request }: { productId: number; request: VerifyCoupangReviewFailureRequest }) =>
      verifyCoupangReviewFailure(productId, request),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['coupang-review-failures'] }),
  });
};
